import React, { useState, useEffect } from "react"
import { FooterRow, GamePlayButton, AnimatedText } from "./FooterStyled"
import {
  Currencies,
  Notifications,
} from "@orbital/games-frontend-library"

import { FOOTER_PROPS } from "./interface"
import {
  stepRound,
  startRound,
  endRound,
  startDoubleUp,
} from "../functions/gameFunctions"
import ButtonText from "./footerElements/buttonText"
import { useErrorHandlers } from "../../components/functions/errorHandlers"
import UpFloor from "./footerElements/upFloor"
import { ChecklastClick } from "../functions/checkClickTime"
import NotifyText from "../../components/text/Text"
import Result from "../../components/result/Result"

export default function Footer({
  handleAbove,
  stake,
  colors,
  stateRound,
  sendSocketMessage,
  holded,
  handleStake,
  canGamble,
  isLoaded,
  sendSettings,
  audio,
  audioUrl,
  gameInfo,
  handleNotification,
  notification,
  setCleared,
  handleClearAnim,
  handleCardFront,
  lastCardRotated,
  handleLastCardRotate,
  cardFront,
  showGamble,
}: FOOTER_PROPS) {
  const { state, winamount, balance } = stateRound
  const { currency, precision } = gameInfo
  const [btnClick, setBtnClick] = useState<string>("")
  const [lastClick, setLastClick] = useState(0)
  const [click, setClick] = useState(true)
  const [disableRow, setDisableRow] = useState<boolean>(false)

  const startGame = () => {
    audioUrl.play()
    if (stake <= balance) {
      startRound(stake, sendSocketMessage)
      sendSettings()
      handleCardFront(false)
      handleLastCardRotate(false)
      setDisableRow(true)
    } else {
      handleNotification(Notifications.notEnoughBalance)
      setDisableRow(false)
      setTimeout(() => {
        setClick(true)
        setBtnClick("")
      }, 167)
    }
  }
  const StepGame = () => {
    audioUrl.deal()
    handleCardFront(false)
    stepRound(holded, sendSocketMessage)
    handleLastCardRotate(false)
  }
  const reset = () => {
    state === 3 && audioUrl.cashout()
    endRound(sendSocketMessage)
  }
  const startGamble = () => {
    audioUrl.gamble()
    setBtnClick("gamble")
    startDoubleUp(sendSocketMessage)
  }

  const handleGamePlay = () => {
    setBtnClick("play")
    setClick(false)
    ChecklastClick(handleClearAnim, lastClick, setLastClick)
    switch (state) {
      case 2:
        StepGame()
        setCleared(false)
        break
      case 3:
        reset()
        setCleared(false)
        break
      case 5:
      case 7:
        startGame()
        setCleared(true)
        break
      default:
        setCleared(true)
        startGame()
        break
    }
  }

  useEffect(() => {
    if (cardFront && lastCardRotated && state !== 7) {
      setBtnClick("")
      setTimeout(() => {
        setClick(true)
      }, 167)
    } else if (state === 7 && lastCardRotated) {
      setTimeout(() => {
        setBtnClick("")
        setTimeout(() => {
          setClick(true)
        }, 167)
      }, 333)
    }
  }, [cardFront, lastCardRotated, state])

  useEffect(() => {
    if ((state === 2 || state === 3 || state === 4) && lastCardRotated) {
      setDisableRow(true)
    } else if (lastCardRotated) {
      setDisableRow(false)
    }
  }, [lastCardRotated, state])

  useErrorHandlers(notification, setBtnClick, setClick, setDisableRow)

  return (
    <>
      <FooterRow
        fadeOut={canGamble && lastCardRotated}
        isClickable={disableRow}
        className="upFloor"
      >
        <NotifyText
          text={"Card hold is available"}
          fadeIn={state === 2 && holded && !holded.includes(1) && isLoaded}
          time={2000}
          position="top"
        />
        <Result
          stateRound={stateRound}
          currency={gameInfo.currency}
          isHolded={holded}
          audio={audio}
          lastCardRotated={lastCardRotated}
          showGamble={showGamble}
          precision={precision}
        />
        <UpFloor
          gameInfo={gameInfo}
          stake={stake}
          audio={audio}
          audioUrl={audioUrl}
          handleStake={handleStake}
          handleAbove={handleAbove}
          handleNotification={handleNotification}
          rowDisabled={disableRow}
        />
      </FooterRow>
      {canGamble && lastCardRotated && (
        <FooterRow>
          <GamePlayButton
            anim={btnClick === "gamble"}
            fadeOut={canGamble && lastCardRotated}
            onClick={() => canGamble && startGamble()}
            isClickable={click}
          >
            <div className="white" />
          </GamePlayButton>
          <AnimatedText
            anim={btnClick === "gamble"}
            fadeIn={canGamble && lastCardRotated}
          >
            gamble
          </AnimatedText>
        </FooterRow>
      )}
      <FooterRow>
        <GamePlayButton
          colors={colors}
          anim={btnClick === "play" && !click}
          onClick={() => handleGamePlay()}
          isClickable={click}
        >
          <ButtonText
            st={state}
            gamble={canGamble}
            win={winamount.toFixed(precision)}
            curr={Currencies[currency]}
            btnCont={click}
            lastCardRotated={lastCardRotated}
          />
          <div className="white" />
        </GamePlayButton>
      </FooterRow>
    </>
  )
}
